'use client';

import styles from './spinner.module.css';

type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';
type SpinnerColor = 'default' | 'primary' | 'neutral';

interface SpinnerProps {
  size?: SpinnerSize;
  color?: SpinnerColor;
}

const sizeClassMap: Record<SpinnerSize, string> = {
  xs: styles.xs,
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
};

// `default` has no class of its own — the base `.spinner` rule already carries
// that look. Typed as possibly-undefined so the lookup can't silently stringify
// a missing entry, which is what put a literal `class="… undefined"` on every
// default-coloured spinner in the DOM.
const colorClassMap: Record<SpinnerColor, string | undefined> = {
  default: undefined,
  primary: styles.primary,
  neutral: styles.neutral,
};

export function Spinner({ size, color = 'default' }: SpinnerProps) {
  const className = [
    styles.spinner,
    'animate-spin',
    size ? sizeClassMap[size] : '',
    colorClassMap[color],
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
}
